<template>
  <component :is="iconComponent" />
</template>

<script>
import { defineAsyncComponent, computed } from 'vue'
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const iconComponent = computed(() =>
      props.category
        ? defineAsyncComponent(
            () => import(`../../icons/${props.category}/${props.name}.svg?component`),
          )
        : defineAsyncComponent(() => import(`../../icons/${props.name}.svg?component`)),
    )
    return {
      iconComponent,
    }
  },
}
</script>
